<template>
    <section class="cards">
        <vnodes
            :nodes="$slots.default"
            :pageNumber="pager.pageNumber"
            :pageSize="pager.pageSize"
            :pagination="pagination"
        />
        <PagerControl
            v-if="$slots.default && $slots.default.length && pagination !== false"
            :length="$slots.default.length"
            v-model="pager"
        />
    </section>
</template>

<script>
import PagerControl from './PagerControl';

export default {
    data: () => {
        return {
            pager: {
                pageSize: '24',
                pageNumber: '1',
            },
        };
    },
    props: {
        pagination: { type: Boolean, default: true },
    },
    components: {
        PagerControl,
        Vnodes: {
            functional: true,
            render: (h, ctx) => {
                const { pageNumber, pageSize, nodes } = ctx.props;
                if (ctx.props.pagination === false) {
                    return nodes;
                }
                if (nodes) {
                    return nodes.slice((pageNumber - 1) * pageSize, pageNumber * pageSize);
                }
                return null;
            },
        },
    },
};
</script>

<style lang="scss">
.cards {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    margin: 20px 30px;

    .card {
        position: relative;
        border: 1px solid #9ca5b0;
        border-radius: 15px;
        background-color: #ffffff;
        margin: 1rem 0.25em;
        display: flex;

        @media screen and (min-width: 20em) {
            flex: 0 1 calc(66% - 1em);
        }
        @media screen and (min-width: 40em) {
            flex: 0 1 calc(50% - 1em);
        }
        @media screen and (min-width: 60em) {
            flex: 0 1 calc(33% - 1em);
        }

        span {
            display: block;
        }

        .card-checkbox {
            border-right: 1px solid #9ca5b0;
            display: flex;
            align-items: center;
            margin-left: 12px;
        }

        .card-content {
            padding: 20px 17px;

            .card-title {
                color: #2a2a2a;
                font-size: 13px;
                font-weight: 600;
                line-height: 18px;
            }

            .card-summary {
                color: #2a2a2a;
                font-size: 13px;
                line-height: 18px;
            }
        }

        &:not(:hover) {
            .card-actions {
                display: none;
            }
        }

        .card-actions {
            position: absolute;
            right: 20px;
            top: 50%;
            transform: translateY(-50%);

            .card-actions--icon {
                height: 23px;
                width: 23px;
                border: 1px solid #6c3e91;
                border-radius: 5px;
                background-color: #6c3e91;
                color: #ffffff;
                padding: 7px;
                margin-left: 9px;
                cursor: pointer;

                &.alert {
                    border: 1px solid #ea5b0c;
                    background-color: #ea5b0c;
                }

                &.enable {
                    border: 1px solid #64aded;
                    background-color: #64aded;
                }

                &.auto {
                    border: 1px solid #96ed64;
                    background-color: #96ed64;
                }

                &.close {
                    border: 1px solid #6cd3fb;
                    background-color: #6cd3fb;
                }

                &.calculate {
                    border: 1px solid #6cd3fb;
                    background-color: #6cd3fb;
                }

                &.automatic {
                    border: 1px solid #96ed64;
                    background-color: #96ed64;
                }

                &.duplicate {
                    border: 1px solid #f09a5b;
                    background-color: #f09a5b;
                }
            }
        }
    }
}
</style>
